// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"ModalWrapperV4_modal-wrapper__YB6m6"};